<script>
  import { createEventDispatcher } from 'svelte';

  // Create an event dispatcher
  const dispatch = createEventDispatcher();

  export let placeholder;

  // Search input value
  let searchInput = '';

  // Function to handle input change
  function handleInput(event) {
    searchInput = event.target.value;
    // Dispatch the search keyword to the parent component
    dispatch('updateSearchKeyword', { value: searchInput });
  }

  function clearInput() {
    searchInput = '';
    dispatch('updateSearchKeyword', { value: searchInput });
  }
</script>

<div class="search-container">
  <!-- Input field for search -->
  <input
    type="text"
    bind:value={searchInput}
    placeholder={placeholder || "Search..."}
    on:input={handleInput}
  />

  {#if searchInput}
    <button on:click={clearInput} class="clear-button" title="Clear">✖</button>
  {/if}
</div>

<style>
  .search-container {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  input,
  input[type=text] {
    padding-right: 30px; /* Give space for the clear button */
    background: white;
    border: 1px solid #ccc;
    padding: 8px;
    font-size: 16px;
    width: 180px;
    margin: 0;
  }

  input:focus-visible {
    outline: none;
    box-shadow: 0 0 1px 2px #aa5526;
  }

  .clear-button {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    cursor: pointer;
    font-size: 13px;
    padding: 3px;
    line-height: 13px;
    width: 1.3rem;
    height: 1.2rem;
    border-radius: 50%;
    background: transparent;
    /* background: linear-gradient(45deg, #00e2f9 1%, #3d76bb 47%, #662d91 97%); */
  }
</style>